import { render, staticRenderFns } from "./user-follow.vue?vue&type=template&id=28fa9712&"
import script from "./user-follow.vue?vue&type=script&lang=js&"
export * from "./user-follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports